var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcStartT2Outlined20Px = function SvgIcStartT2Outlined20Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm2.768 8.577a.5.5 0 0 1 0 .848l-4.002 2.498A.5.5 0 0 1 8 12.498V7.503c0-.392.44-.631.773-.423l3.995 2.497Zm.529 1.696a1.5 1.5 0 0 0 0-2.544L9.304 6.232C8.304 5.607 7 6.325 7 7.504V10l.008.002L7 12.495c-.003 1.18 1.295 1.901 2.295 1.277l4.002-2.499Z",
    clipRule: "evenodd"
  })));
};
export default SvgIcStartT2Outlined20Px;